import { getData } from "./apiService.js";
export async function getMembers(params = {}) {
    let response = await getData("members/get", params);
    return response.data;
  }